import React from 'react';
import HelpandSupportView from '../../Views/AfterAuth/MyProfileView/HelpandSupportView/HelpandSupportView';

const HelpAndSupport = () => {
    return <HelpandSupportView />;
};

export default HelpAndSupport;
